import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'pr-invoice-line-item-header',
    templateUrl: './invoice-line-item-header.component.html',
    styleUrls: ['./invoice-line-item-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InvoiceLineItemHeaderComponent {}
